<template>
  <div>
    <header class="page-header">
      <b-breadcrumb :items="breadcrumb" class="append"></b-breadcrumb>
    </header>
    <div class="Info_Area">
      <h2>群組權限</h2>
      <b-container class="containerstyle">
        <b-row>
          <b-col cols="4">
            <b-input-group>
              <b-input-group-prepend is-text>
                群組名稱
              </b-input-group-prepend>
              <b-form-input
                id="email-input"
                v-model="groupInfo.property.AG_NAME"
                :state="groupInfo.property.state"
                aria-describedby="group-name-feedback"
                @input="fullnameverify"
                :disabled="
                  groupInfo.property.AG_ID == '0' ||
                    groupInfo.property.AG_ID == '5'
                "
                required
              ></b-form-input>
              <b-form-invalid-feedback id="group-name-feedback">
                欄位不能空白
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="header1" cols="2"><h5>產銷儀表板:</h5></b-col>
          <b-col cols="3">
            <h6>農產品交易價量分析</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.saledasboard.farmdashboard.value"
            >
              <b-form-radio value="PJ000000000002">檢視</b-form-radio>
              <b-form-radio value="PJ000000000026">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col cols="3">
            <h6>漁產品交易價量分析</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.saledasboard.fishdashboard.value"
            >
              <b-form-radio value="PJ000000000003">檢視</b-form-radio>
              <b-form-radio value="PJ000000000027">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col cols="3">
            <h6>畜產品交易價量分析</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.saledasboard.animaldashboard.value"
            >
              <b-form-radio value="PJ000000000004">檢視</b-form-radio>
              <b-form-radio value="PJ000000000028">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col cols="3">
            <h6>稻作交易價量分析</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.saledasboard.cropboard.value"
            >
              <b-form-radio value="PJ000000000005">檢視</b-form-radio>
              <b-form-radio value="PJ000000000029">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="header1" cols="2"><h5>資料管理:</h5></b-col>
          <b-col>
            <h6>農產品價格維護</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.farm.value"
            >
              <b-form-checkbox value="PJ000000000006">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000007">新增</b-form-checkbox>
              <b-form-checkbox value="PJ000000000008">編輯</b-form-checkbox>
              <b-form-checkbox value="PJ000000000009">刪除</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>產地價格監控</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.farmMaintain.value"
            >
              <b-form-checkbox value="PJ000000000030">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000031">編輯</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>漁產品價格維護</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.fish.value"
            >
              <b-form-checkbox value="PJ000000000010">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000011">新增</b-form-checkbox>
              <b-form-checkbox value="PJ000000000012">編輯</b-form-checkbox>
              <b-form-checkbox value="PJ000000000013">刪除</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>畜產品價格維護</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.animal.value"
            >
              <b-form-checkbox value="PJ000000000014">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000015">新增</b-form-checkbox>
              <b-form-checkbox value="PJ000000000016">編輯</b-form-checkbox>
              <b-form-checkbox value="PJ000000000017">刪除</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>稻作價格維護</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.crop.value"
            >
              <b-form-checkbox value="PJ000000000018">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000019">新增</b-form-checkbox>
              <b-form-checkbox value="PJ000000000020">編輯</b-form-checkbox>
              <b-form-checkbox value="PJ000000000021">刪除</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>病蟲害資料維護</h6>
          </b-col>
          <b-col cols="7">
            <b-form-checkbox-group
              v-model="groupInfo.datamanagement.pent.value"
            >
              <b-form-checkbox value="PJ000000000022">檢視</b-form-checkbox>
              <b-form-checkbox value="PJ000000000023">新增</b-form-checkbox>
              <!-- <b-form-checkbox value="PJ000000000024">編輯</b-form-checkbox> -->
              <b-form-checkbox value="PJ000000000025">刪除</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="header1" cols="2"><h5>帳號權限管理:</h5></b-col>
          <b-col>
            <h6></h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group v-model="groupInfo.account.value">
              <b-form-radio value="PJ000000000001">有</b-form-radio>
              <b-form-radio value="PJ000000000000">無</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="header1" cols="2"><h5>主管業務專區:</h5></b-col>
          <b-col>
            <h6>農業專區</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.datamanagement.manager.cropValue"
            >
              <b-form-radio value="PJ000000000032">檢視</b-form-radio>
              <b-form-radio value="PJ000000000033">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>漁業專區</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.datamanagement.manager.fishValue"
            >
              <b-form-radio value="PJ000000000037">檢視</b-form-radio>
              <b-form-radio value="PJ000000000038">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"></b-col>
          <b-col>
            <h6>畜產專區</h6>
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.datamanagement.manager.animalValue"
            >
              <b-form-radio value="PJ000000000039">檢視</b-form-radio>
              <b-form-radio value="PJ000000000040">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="header1" cols="2"><h5>自定義圖表分析:</h5></b-col>
          <b-col cols="3">
            
          </b-col>
          <b-col cols="7">
            <b-form-radio-group
              v-model="groupInfo.datamanagement.customize.value"
            >
              <b-form-radio value="PJ000000000034">全部資訊</b-form-radio>
              <b-form-radio value="PJ000000000035">不含產地均價、產地價格監控</b-form-radio>
              <b-form-radio value="PJ000000000036">隱藏</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
      </b-container>
      <hr />
      <b-row>
        <b-col md="auto">
          <b-button
            @click="toUpdateAccountGroup(2)"
            class="mr-2"
            variant="primary"
            >儲存</b-button
          >
        </b-col>
        <b-col v-if="canDelete">
          <b-button @click="toDeleteAccountGroup" variant="danger"
            >刪除</b-button
          >
          <div id="emailHelp" class="form-text">
            若刪除此群組，此群組將被永久刪除，無法復原
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "GroupInfo",
  data() {
    return {
      id: this.$route.params.id,
      name: "",
      breadcrumb: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "帳號權限管理",
          href: "#",
        },
        {
          text: "群組權限管理",
          to: "/Authority",
        },
        {
          text: "",
          active: true,
        },
      ],
      authData: {
        AG_ID: this.$route.params.id,
        AG_PJID: [],
      },
      groupInfo: {
        property: {
          AG_ID: "",
          AG_NAME: "",
          AG_PJID: "",
          AG_MDATE: "",
          AG_MUSERID: "",
          AG_EDATE: "",
          AG_EUSERID: "",
          AG_TYPE: "",
          AG_ISDEL: "",
          state: null,
        },
        home: {
          value: null,
        },
        gis: {
          value: null,
        },
        saledasboard: {
          farmdashboard: {
            value: null,
          },
          animaldashboard: {
            value: null,
          },
          fishdashboard: {
            value: null,
          },
          cropboard: {
            value: null,
          },
        },
        datamanagement: {
          farm: {
            value: [],
          },
          farmMaintain: {
            value: [],
          },
          fish: {
            value: [],
          },
          animal: {
            value: [],
          },
          crop: {
            value: [],
          },
          pent: {
            value: [],
          },
          manager: {
            cropValue: null,
            fishValue: null,
            animalValue: null,
            value: null,
          },
          customize: {
            value: null,
          },
        },
        account: {
          value: null,
        },
      },
      AG_NAME: "",
      account: "",
      canDelete: false,
      apiAccountGroupGet: (data) =>
        this.userRequest.post("/API/Default/AccountGroupGet", data),
      apiAccountGroupUpdate: (data) =>
        this.userRequest.post("/API/Default/AccountGroupUpdate", data),
      apiDeleteAccountGroup: (data) =>
        this.userRequest.post("/API/Default/DeleteAccountGroup", data),
    };
  },
  mounted() {
    this.FunctionToken(this.getAccountGroup, { AG_ID: this.id });
    // this.checkPermission()
  },
  methods: {
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000001", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("你沒有權限檢視");
        this.$router.push({ path: "/" });
      } else {
        this.FunctionToken(this.getAccountGroup, { AG_ID: this.id });
      }
    },
    getAccountGroup(data) {
      this.apiAccountGroupGet(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Data == "無此資料") {
            alert("沒有該筆資料");
            this.$router.push({ path: "/" });
          } else if (json.Status) {
            this.groupInfo.property = JSON.parse(json.Data);
            this.groupInfo.property.AG_PJID != null
              ? this.permissionmapping()
              : [];
            this.canDelete = !(
              this.groupInfo.property.AG_ID == "0" ||
              this.groupInfo.property.AG_ID == "5"
            );
            this.breadcrumb = [
              {
                text: "首頁",
                href: "#",
              },
              {
                text: "帳號權限管理",
                href: "#",
              },
              {
                text: "群組權限管理",
                to: "/Authority",
              },
              {
                text: this.groupInfo.property.AG_NAME,
                active: true,
              },
            ];
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    permissionmapping() {
      let arr = this.groupInfo.property.AG_PJID.split(",");
      console.log(arr);
      for (let i in arr) {
        let item = arr[i].replace(/[^a-zA-Z0-9 ]/g, "").trim();
        switch (item) {
          case "PJ000000000000":
          case "PJ000000000001":
            this.groupInfo.account.value = item;
            break;
          case "PJ000000000002":
          case "PJ000000000026":
            this.groupInfo.saledasboard.farmdashboard.value = item;
            break;
          case "PJ000000000003":
          case "PJ000000000027":
            this.groupInfo.saledasboard.fishdashboard.value = item;
            break;
          case "PJ000000000004":
          case "PJ000000000028":
            this.groupInfo.saledasboard.animaldashboard.value = item;
            break;
          case "PJ000000000005":
          case "PJ000000000029":
            this.groupInfo.saledasboard.cropboard.value = item;
            break;
          case "PJ000000000006":
          case "PJ000000000007":
          case "PJ000000000008":
          case "PJ000000000009":
            this.groupInfo.datamanagement.farm.value.push(item);
            break;
          case "PJ000000000030":
          case "PJ000000000031":
            this.groupInfo.datamanagement.farmMaintain.value.push(item);
            break;
          case "PJ000000000010":
          case "PJ000000000011":
          case "PJ000000000012":
          case "PJ000000000013":
            this.groupInfo.datamanagement.fish.value.push(item);
            break;
          case "PJ000000000014":
          case "PJ000000000015":
          case "PJ000000000016":
          case "PJ000000000017":
            this.groupInfo.datamanagement.animal.value.push(item);
            break;
          case "PJ000000000018":
          case "PJ000000000019":
          case "PJ000000000020":
          case "PJ000000000021":
            this.groupInfo.datamanagement.crop.value.push(item);
            break;
          case "PJ000000000022":
          case "PJ000000000023":
          case "PJ000000000025":
            this.groupInfo.datamanagement.pent.value.push(item);
            break;
          case "PJ000000000032":
          case "PJ000000000033":
            this.groupInfo.datamanagement.manager.cropValue = item;
            break;
          case "PJ000000000034":
          case "PJ000000000035":
          case "PJ000000000036":
            this.groupInfo.datamanagement.customize.value = item;
            break;
          case "PJ000000000037":
          case "PJ000000000038":
            this.groupInfo.datamanagement.manager.fishValue= item;
            break;
          case "PJ000000000039":
          case "PJ000000000040":
            this.groupInfo.datamanagement.manager.animalValue = item;
            break;  
          
        }
      }
    },
    toUpdateAccountGroup() {
      this.FunctionToken(this.AccountGroupUpdate, {
        AG_ID: this.groupInfo.property.AG_ID,
        AG_NAME: this.groupInfo.property.AG_NAME,
        AG_PJID: this.permissioncollection(),
      });
    },
    permissioncollection() {
      let obj = [];
      if (this.IsNull(this.groupInfo.account.value) != "")
        obj.push(this.groupInfo.account.value);
      // if(this.IsNull(this.groupInfo.home.value)!='') obj.push(this.groupInfo.home.value)
      //if (this.IsNull(this.groupInfo.gis.value) != "") obj.push(this.groupInfo.gis.value);
      if (this.IsNull(this.groupInfo.saledasboard.farmdashboard.value) != "")
        obj.push(this.groupInfo.saledasboard.farmdashboard.value);
      if (this.IsNull(this.groupInfo.saledasboard.fishdashboard.value) != "")
        obj.push(this.groupInfo.saledasboard.fishdashboard.value);
      if (this.IsNull(this.groupInfo.saledasboard.animaldashboard.value) != "")
        obj.push(this.groupInfo.saledasboard.animaldashboard.value);
      if (this.IsNull(this.groupInfo.saledasboard.cropboard.value) != "")
        obj.push(this.groupInfo.saledasboard.cropboard.value);
      if (this.groupInfo.datamanagement.farm.value.length != 0)
        obj.push(this.groupInfo.datamanagement.farm.value.toString());
        if (this.groupInfo.datamanagement.farmMaintain.value.length != 0)
        obj.push(this.groupInfo.datamanagement.farmMaintain.value.toString());
      if (this.groupInfo.datamanagement.fish.value.length != 0)
        obj.push(this.groupInfo.datamanagement.fish.value.toString());
      if (this.groupInfo.datamanagement.animal.value.length != 0)
        obj.push(this.groupInfo.datamanagement.animal.value.toString());
      if (this.groupInfo.datamanagement.crop.value.length != 0)
        obj.push(this.groupInfo.datamanagement.crop.value.toString());
      if (this.groupInfo.datamanagement.pent.value.length != 0)
        obj.push(this.groupInfo.datamanagement.pent.value.toString());
      if (this.groupInfo.datamanagement.manager.cropValue != null)
        obj.push(this.groupInfo.datamanagement.manager.cropValue.toString());
      if (this.groupInfo.datamanagement.manager.fishValue != null)
        obj.push(this.groupInfo.datamanagement.manager.fishValue.toString());
      if(this.groupInfo.datamanagement.manager.animalValue != null)
        obj.push(this.groupInfo.datamanagement.manager.animalValue.toString());
      if (this.groupInfo.datamanagement.customize.value != null)
        obj.push(this.groupInfo.datamanagement.customize.value.toString());
      return obj.toString();
    },
    AccountGroupUpdate(data) {
      this.apiAccountGroupUpdate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          alert(json.Message);
          if (json.Status) {
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    toDeleteAccountGroup() {
      this.FunctionToken(this.DeleteAccountGroup, {
        AG_ID: this.groupInfo.property.AG_ID,
      });
    },
    DeleteAccountGroup(data) {
      this.apiDeleteAccountGroup(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert(json.Message);
            this.$router.go(-1);
          } else {
            alert(json.Data);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    fullnameverify() {
      this.groupInfo.property.state =
        this.IsNull(this.groupInfo.property.AG_NAME) == "" ? false : true;
    },
  },
};
</script>

<style>

.header1 {
  font-weight: bold;
}
.containerstyle {
  margin-left: unset !important;
}
</style>
